import { render, staticRenderFns } from "./NavigationHeader.vue?vue&type=template&id=23098798&scoped=true&"
import script from "./NavigationHeader.vue?vue&type=script&lang=ts&"
export * from "./NavigationHeader.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationHeader.vue?vue&type=style&index=0&id=23098798&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23098798",
  null
  
)

export default component.exports